import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getConferenceSettings } from '../services/conferenceSettingsService';
import { getSiteSettings } from '../services/siteSettingsService';

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [siteSettings, setSiteSettings] = useState(null);
  const [conferenceSettings, setConferenceSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    Promise.all([getSiteSettings(), getConferenceSettings()])
      .then(([site, conference]) => {
        if (!mounted) return;
        setSiteSettings(site);
        setConferenceSettings(conference);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  const value = useMemo(
    () => ({
      siteSettings,
      conferenceSettings,
      loading,
    }),
    [siteSettings, conferenceSettings, loading]
  );

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
